export default "__VITE_ASSET__d6Ml0NtX__"